import {
  CLIENT_FACING_TASK_TAG_CODE,
  CLIENT_FACING_TASK_TAG_SYSTEM,
} from './taskFhirConstants';

/** Client-facing Tasks for a portal patient. Fetch filters with isClientFacingTask(). */
export function buildClientPortalTaskSubscriptionCriteria(patientId: string): string {
  return buildPatientTaskSubscriptionCriteria(patientId);
}

/** @deprecated Prefer buildClientPortalTaskSubscriptionCriteria — _tag breaks WS delivery. */
export function buildClientFacingTaskSubscriptionCriteria(patientId: string): string {
  const patientRef = `Patient/${patientId}`;
  const tag = `${CLIENT_FACING_TASK_TAG_SYSTEM}|${CLIENT_FACING_TASK_TAG_CODE}`;
  return `Task?patient=${encodeURIComponent(patientRef)}&_tag=${encodeURIComponent(tag)}`;
}

/** Shared files / uploads visible on client portal Documents. */
export function buildPatientDocumentReferenceSubscriptionCriteria(patientId: string): string {
  return `DocumentReference?subject=${encodeURIComponent(`Patient/${patientId}`)}`;
}

/** Completed forms on client portal Documents. */
export function buildPatientQuestionnaireResponseSubscriptionCriteria(patientId: string): string {
  return `QuestionnaireResponse?subject=${encodeURIComponent(`Patient/${patientId}`)}`;
}

/** Provider chart: appointments for one patient. */
export function buildPatientAppointmentSubscriptionCriteria(patientId: string): string {
  return `Appointment?patient=${encodeURIComponent(`Patient/${patientId}`)}`;
}

/** Provider calendar: appointments where a practitioner is an actor (portal cancels, edits, etc.). */
export function buildPractitionerAppointmentSubscriptionCriteria(practitionerId: string): string {
  return `Appointment?actor=${encodeURIComponent(`Practitioner/${practitionerId}`)}`;
}

/** Appointment detail page: one appointment (e.g. session transcript / pipeline status updates). */
export function buildAppointmentByIdSubscriptionCriteria(appointmentId: string): string {
  return `Appointment?_id=${encodeURIComponent(appointmentId)}`;
}

/** Encounter detail (e.g. bot session-timing extension updates). */
export function buildEncounterByIdSubscriptionCriteria(encounterId: string): string {
  return `Encounter?_id=${encodeURIComponent(encounterId)}`;
}

/** Appointment notes linked to an encounter. */
export function buildEncounterQuestionnaireResponseSubscriptionCriteria(encounterId: string): string {
  return `QuestionnaireResponse?encounter=${encodeURIComponent(`Encounter/${encounterId}`)}`;
}

/** Provider chart: all Tasks for one patient (forms, assignments, etc.). */
export function buildPatientTaskSubscriptionCriteria(patientId: string): string {
  return `Task?patient=${encodeURIComponent(`Patient/${patientId}`)}`;
}
